export const FOOTER_LINK_CLASS = 'text-sm text-copy-muted transition-colors hover:text-title-2';
export const FOOTER_COLUMN_TITLE_CLASS = 'label-caps text-copy-muted';
